// import React, { useState, useEffect } from 'react';
// import styles from './OrderDetail.module.css';
// import { orderHeaderApi } from '../../../../../api/orderHeader/orderHeaderApi';

// const OrderDetail = ({ initialOrderNum, onBack }) => {
//   const [orderNum, setOrderNum] = useState(initialOrderNum || '');
//   const [order, setOrder] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (orderNum) {
//       fetchOrderDetails();
//     }
//   }, [orderNum]);

//   useEffect(() => {
//     if (initialOrderNum) {
//       setOrderNum(initialOrderNum);
//     }
//   }, [initialOrderNum]);

//   const fetchOrderDetails = async () => {
//     try {
//       setLoading(true);
//       setError(null);
//       const data = await orderHeaderApi.getOrderDetails(orderNum);
//       setOrder(data);
//     } catch (err) {
//       setError('Failed to load order details');
//       setOrder(null);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatCurrency = (amount) => {
//     return '₹' + (amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
//   };

//   const formatTime = (timeValue) => {
//     if (!timeValue) return 'N/A';
//     try {
//       const date = new Date(timeValue);
//       if (isNaN(date.getTime())) return 'N/A';
//       return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
//     } catch {
//       return 'N/A';
//     }
//   };

//   return (
//     <div className={styles.wrapper}>
//       {/* Back button */}
//       <div className={styles.backRow}>
//         <button onClick={onBack} className={styles.backButton}>
//           ← Back to Order Headers
//         </button>
//         {order && (
//           <span className={styles.orderTitle}>Order #{order.orderNum}</span>
//         )}
//       </div>

//       {loading && (
//         <div className={styles.loadingContainer}>
//           <div className={styles.loadingSpinner} />
//           <div className={styles.loadingText}>Loading order details...</div>
//         </div>
//       )}

//       {error && <div className={styles.errorMessage}>{error}</div>}

//       {order && !loading && (
//         <>
//           {/* Order Information */}
//           <div className={styles.card}>
//             <h2 className={styles.cardHeader}>Order Information</h2>
//             <div className={styles.grid}>
//               <div className={styles.field}>
//                 <label className={styles.label}>Order #</label>
//                 <span className={styles.value}>{order.orderNum}</span>
//               </div>
//               <div className={styles.field}>
//                 <label className={styles.label}>Status</label>
//                 <span className={`${styles.statusBadge} ${styles[`status${order.orderStatus}`]}`}>
//                   {order.orderStatus}
//                 </span>
//               </div>
//               <div className={styles.field}>
//                 <label className={styles.label}>Customer PO No</label>
//                 <span className={styles.value}>{order.customerPoNo || 'N/A'}</span>
//               </div>
//               <div className={styles.field}>
//                 <label className={styles.label}>Order Date</label>
//                 <span className={styles.value}>{formatDate(order.orderDate)}</span>
//               </div>
//               <div className={styles.field}>
//                 <label className={styles.label}>Order Time</label>
//                 <span className={styles.value}>{formatTime(order.orderTime)}</span>
//               </div>
//               <div className={styles.field}>
//                 <label className={styles.label}>Delivery Date</label>
//                 <span className={styles.value}>{formatDate(order.deliveryDate)}</span>
//               </div>
//               <div className={styles.field}>
//                 <label className={styles.label}>Payment Terms</label>
//                 <span className={styles.value}>{order.paymentTerms || 'N/A'}</span>
//               </div>
//             </div>
//           </div>

//           {/* Customer Information */}
//           <div className={styles.card}>
//             <h2 className={styles.cardHeader}>Customer Information</h2>
//             <div className={styles.grid}>
//               <div className={styles.field}>
//                 <label className={styles.label}>Customer Name</label>
//                 <span className={styles.value}>{order.customerCode}</span>
//               </div>
//               <div className={styles.field}>
//                 <label className={styles.label}>Contact Person</label>
//                 <span className={styles.value}>{order.contactPerson || 'N/A'}</span>
//               </div>
//               <div className={styles.field}>
//                 <label className={styles.label}>Phone</label>
//                 <span className={styles.value}>{order.phone || 'N/A'}</span>
//               </div>
//               <div className={styles.field}>
//                 <label className={styles.label}>Email</label>
//                 <span className={styles.value}>{order.email || 'N/A'}</span>
//               </div>
//               <div className={styles.field}>
//                 <label className={styles.label}>Sales Employee</label>
//                 <span className={styles.value}>{order.salesEmployeeName || 'N/A'}</span>
//               </div>
//             </div>
//           </div>

//           {/* Financial Summary */}
//           <div className={styles.card}>
//             <h2 className={styles.cardHeader}>Financial Summary</h2>
//             <div className={styles.grid}>
//               <div className={styles.field}>
//                 <label className={styles.label}>Subtotal</label>
//                 <span className={styles.value}>{formatCurrency(order.subtotal)}</span>
//               </div>
//               <div className={styles.field}>
//                 <label className={styles.label}>Tax Total</label>
//                 <span className={styles.value}>{formatCurrency(order.taxTotal)}</span>
//               </div>
//               <div className={styles.field}>
//                 <label className={styles.label}>Discount Total</label>
//                 <span className={styles.value}>{formatCurrency(order.discountTotal)}</span>
//               </div>
//               <div className={styles.field}>
//                 <label className={styles.label}>Shipping Fee</label>
//                 <span className={styles.value}>{formatCurrency(order.shippingFee)}</span>
//               </div>
//               <div className={styles.field}>
//                 <label className={styles.label}>Total Amount</label>
//                 <span className={styles.totalAmount}>{formatCurrency(order.totalAmount)}</span>
//               </div>
//             </div>
//           </div>

//           {/* Addresses */}
//           <div className={styles.card}>
//             <h2 className={styles.cardHeader}>Addresses</h2>
//             <div className={styles.addressGrid}>
//               <div className={styles.addressBox}>
//                 <label className={styles.addressLabel}>Billing Address</label>
//                 <div className={styles.addressContent}>{order.billingAddress || 'N/A'}</div>
//               </div>
//               <div className={styles.addressBox}>
//                 <label className={styles.addressLabel}>Shipping Address</label>
//                 <div className={styles.addressContent}>{order.shippingAddress || 'N/A'}</div>
//               </div>
//             </div>
//           </div>

//           {/* Comments */}
//           {order.comments && (
//             <div className={styles.card}>
//               <h2 className={styles.cardHeader}>Comments</h2>
//               <div className={styles.commentsBox}>{order.comments}</div>
//             </div>
//           )}
//         </>
//       )}

//       {!order && !loading && (
//         <div className={styles.emptyState}>
//           <div className={styles.emptyIcon}>📋</div>
//           <div className={styles.emptyText}>No order selected</div>
//           <button onClick={onBack} className={styles.backButton} style={{ marginTop: 16 }}>
//             ← Go to Order Headers
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrderDetail;

import React, { useState, useEffect } from 'react';
import styles from './OrderDetail.module.css';
import { orderHeaderApi } from '../../../../../api/orderHeader/orderHeaderApi';

const OrderDetail = ({ initialOrderNum, onBack }) => {
  const [orderNum, setOrderNum] = useState(initialOrderNum || '');
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0, data: null });

  useEffect(() => {
    if (orderNum) fetchOrderDetails();
  }, [orderNum]);

  useEffect(() => {
    if (initialOrderNum) setOrderNum(initialOrderNum);
  }, [initialOrderNum]);

  const fetchOrderDetails = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await orderHeaderApi.getOrderDetails(orderNum);
      setOrder(data);
    } catch (err) {
      setError('Failed to load order details');
      setOrder(null);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount) =>
    '₹' + (amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  // FIX: parse LocalDateTime from Spring → show HH:MM:SS
  const formatTime = (timeValue) => {
    if (!timeValue) return 'N/A';
    try {
      const date = new Date(timeValue);
      if (isNaN(date.getTime())) return 'N/A';
      return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    } catch {
      return 'N/A';
    }
  };

  // Tooltip handlers
  const handleInvoiceMouseEnter = (e, item) => {
  const rect = e.currentTarget.getBoundingClientRect();
  setTooltip({
    visible: true,
    x: rect.left,
    y: rect.bottom + 6,
    data: item,
  });
};

  const handleInvoiceMouseLeave = () => {
    setTooltip({ visible: false, x: 0, y: 0, data: null });
  };

  return (
    <div className={styles.wrapper}>
      {/* Tooltip */}
      {tooltip.visible && tooltip.data && (
        <div
          className={styles.tooltip}
          style={{ top: tooltip.y, left: tooltip.x }}
        >
          <div className={styles.tooltipRow}>
            <span className={styles.tooltipLabel}>Tracking No</span>
            <span className={styles.tooltipValue}>{tooltip.data.trackingNo || 'N/A'}</span>
          </div>
          <div className={styles.tooltipRow}>
            <span className={styles.tooltipLabel}>Delivery Date</span>
            <span className={styles.tooltipValue}>{formatDate(tooltip.data.invoiceDeliveryDate)}</span>
          </div>
          <div className={styles.tooltipRow}>
            <span className={styles.tooltipLabel}>Dispatch Date</span>
            <span className={styles.tooltipValue}>{formatDate(tooltip.data.dispatchDate)}</span>
          </div>
          <div className={styles.tooltipRow}>
            <span className={styles.tooltipLabel}>Courier Service</span>
            <span className={styles.tooltipValue}>{tooltip.data.courierService || 'N/A'}</span>
          </div>
        </div>
      )}

      {/* Back button */}
      <div className={styles.backRow}>
        <button onClick={onBack} className={styles.backButton}>← Back to Order Headers</button>
        {order && <span className={styles.orderTitle}>Order #{order.orderNum}</span>}
      </div>

      {loading && (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingSpinner} />
          <div className={styles.loadingText}>Loading order details...</div>
        </div>
      )}

      {error && <div className={styles.errorMessage}>{error}</div>}

      {order && !loading && (
        <>
          {/* Order Information */}
          <div className={styles.card}>
            <h2 className={styles.cardHeader}>Order Information</h2>
            <div className={styles.grid}>
              <div className={styles.field}>
                <label className={styles.label}>Order #</label>
                <span className={styles.value}>{order.orderNum}</span>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Status</label>
                <span className={`${styles.statusBadge} ${styles[`status${order.orderStatus}`]}`}>
                  {order.orderStatus}
                </span>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Customer PO No</label>
                <span className={styles.value}>{order.customerPoNo || 'N/A'}</span>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Order Date</label>
                <span className={styles.value}>{formatDate(order.orderDate)}</span>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Order Time</label>
                <span className={styles.value}>{formatTime(order.orderTime)}</span>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Delivery Date</label>
                <span className={styles.value}>{formatDate(order.deliveryDate)}</span>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Payment Terms</label>
                <span className={styles.value}>{order.paymentTerms || 'N/A'}</span>
              </div>
            </div>
          </div>

          {/* Customer Information */}
          <div className={styles.card}>
            <h2 className={styles.cardHeader}>Customer Information</h2>
            <div className={styles.grid}>
              <div className={styles.field}>
                <label className={styles.label}>Customer Name</label>
                <span className={styles.value}>{order.customerCode}</span>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Contact Person</label>
                <span className={styles.value}>{order.contactPerson || 'N/A'}</span>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Phone</label>
                <span className={styles.value}>{order.phone || 'N/A'}</span>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Email</label>
                <span className={styles.value}>{order.email || 'N/A'}</span>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Sales Employee</label>
                <span className={styles.value}>{order.salesEmployeeName || 'N/A'}</span>
              </div>
            </div>
          </div>

          {/* Financial Summary */}
          <div className={styles.card}>
            <h2 className={styles.cardHeader}>Financial Summary</h2>
            <div className={styles.grid}>
              <div className={styles.field}>
                <label className={styles.label}>Subtotal</label>
                <span className={styles.value}>{formatCurrency(order.subtotal)}</span>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Tax Total</label>
                <span className={styles.value}>{formatCurrency(order.taxTotal)}</span>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Discount Total</label>
                <span className={styles.value}>{formatCurrency(order.discountTotal)}</span>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Shipping Fee</label>
                <span className={styles.value}>{formatCurrency(order.shippingFee)}</span>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Total Amount</label>
                <span className={styles.totalAmount}>{formatCurrency(order.totalAmount)}</span>
              </div>
            </div>
          </div>

          {/* Line Items */}
          {order.lineItems && order.lineItems.length > 0 && (
            <div className={styles.card}>
              <h2 className={styles.cardHeader}>Line Items</h2>
              <div className={styles.lineTableWrapper}>
                <table className={styles.lineTable}>
                  <thead>
                    <tr>
                      <th className={styles.lineTh}>Line #</th>
                      <th className={styles.lineTh}>Item Code</th>
                      <th className={styles.lineTh}>CAS No</th>
                      <th className={styles.lineTh}>Invoice No</th>
                      <th className={styles.lineTh}>Stock</th>
                      <th className={styles.lineTh}>Status</th>
                      <th className={styles.lineTh}>Description</th>
                      <th className={styles.lineTh}>Delivery Date</th>
                      <th className={styles.lineTh}>Quantity</th>
                      <th className={styles.lineTh}>Unit</th>
                      <th className={styles.lineTh}>Price</th>
                      <th className={styles.lineTh}>Discount (%)</th>
                      <th className={styles.lineTh}>Tax Code</th>
                      <th className={styles.lineTh}>Line Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {order.lineItems.map((item, idx) => (
                      <tr key={idx} className={styles.lineTr}>
                        <td className={styles.lineTd}>{item.lineNum}</td>
                        <td className={styles.lineTd}>{item.itemCode || 'N/A'}</td>
                        <td className={styles.lineTd}>{item.casNo || 'N/A'}</td>
                        <td className={styles.lineTd}>
                          {item.invoiceNo ? (
                            <span
                              className={styles.invoiceCell}
                              onMouseEnter={(e) => handleInvoiceMouseEnter(e, item)}
                              onMouseLeave={handleInvoiceMouseLeave}
                            >
                              {item.invoiceNo}
                              <span className={styles.invoiceHint}>ⓘ</span>
                            </span>
                          ) : 'N/A'}
                        </td>
                        <td className={styles.lineTd}>
                          <span className={`${styles.stockBadge} ${item.stockStatus === 'In Stock' ? styles.stockIn : styles.stockOut}`}>
                            {item.stockStatus}
                          </span>
                        </td>
                        <td className={styles.lineTd}>
                          <span className={`${styles.statusBadge} ${item.lineStatus === 'Open' ? styles.statusOpen : styles.statusClosed}`}>
                            {item.lineStatus}
                          </span>
                        </td>
                        <td className={styles.lineTd}>
                          <div className={styles.descCell}>{item.description || 'N/A'}</div>
                        </td>
                        <td className={styles.lineTd}>{formatDate(item.deliveryDate)}</td>
                        <td className={styles.lineTd}>{item.quantity?.toFixed(2) || '0.00'}</td>
                        <td className={styles.lineTd}>{item.unit || 'N/A'}</td>
                        <td className={styles.lineTd}>{formatCurrency(item.price)}</td>
                        <td className={styles.lineTd}>{item.discountPercent?.toFixed(2) || '0.00'}%</td>
                        <td className={styles.lineTd}>{item.taxCode || 'N/A'}</td>
                        <td className={styles.lineTd}>{formatCurrency(item.lineTotal)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Addresses */}
          <div className={styles.card}>
            <h2 className={styles.cardHeader}>Addresses</h2>
            <div className={styles.addressGrid}>
              <div className={styles.addressBox}>
                <label className={styles.addressLabel}>Billing Address</label>
                <div className={styles.addressContent}>{order.billingAddress || 'N/A'}</div>
              </div>
              <div className={styles.addressBox}>
                <label className={styles.addressLabel}>Shipping Address</label>
                <div className={styles.addressContent}>{order.shippingAddress || 'N/A'}</div>
              </div>
            </div>
          </div>

          {/* Comments */}
          {order.comments && (
            <div className={styles.card}>
              <h2 className={styles.cardHeader}>Comments</h2>
              <div className={styles.commentsBox}>{order.comments}</div>
            </div>
          )}
        </>
      )}

      {!order && !loading && (
        <div className={styles.emptyState}>
          <div className={styles.emptyIcon}>📋</div>
          <div className={styles.emptyText}>No order selected</div>
          <button onClick={onBack} className={styles.backButton} style={{ marginTop: 16 }}>
            ← Go to Order Headers
          </button>
        </div>
      )}
    </div>
  );
};

export default OrderDetail;